import { api } from './api';
import { PhotoEntity } from './userApi';

export const photoApi = api.injectEndpoints({
  endpoints: (builder) => ({
    adminCreatePhoto: builder.mutation<
      PhotoEntity,
      { userId: string; formData: FormData }
    >({
      query: ({ formData }) => ({
        url: '/photos/create',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: (_r, _e, { userId }) => [
        { type: 'UserProfile', id: userId },
      ],
    }),
    adminDeletePhoto: builder.mutation<
      void,
      { userId: string; photoId: string }
    >({
      query: ({ photoId }) => ({
        url: `/photos/delete/${photoId}`,
        method: 'PATCH',
      }),
      invalidatesTags: (_r, _e, { userId }) => [
        { type: 'UserProfile', id: userId },
      ],
    }),
  }),
});

export const { useAdminCreatePhotoMutation, useAdminDeletePhotoMutation } =
  photoApi;
